import { gql } from '@apollo/client';
import carPrice from './carPrice';
import price from './price';

const prices = {
  PRICES: gql`
    ${carPrice.CAR_PRICE}
    ${price.PRICE}
    fragment Prices on Prices {
      carPrice {
        ...CarPrice
      }
      totalFeatures {
        ...Price
      }
      totalConfiguration {
        ...Price
      }
      totalPrice {
        ...Price
      }
    }
  `,
};
export default prices;
